export function ZipCodeFilter() {
  return zip => (zip || '').substring(0, 5);
}
